export default __webpack_public_path__ + "static/media/app-design.2531577e.svg";